// extracted by mini-css-extract-plugin
export default {"section":"HelpEntry_section__Hlu2G","sectionExpanded":"HelpEntry_sectionExpanded__hqpTI","headline":"HelpEntry_headline__P-Sof","headlineOpen":"HelpEntry_headlineOpen__WlyxV"};